import { render, staticRenderFns } from "./Cookie_Policy.vue?vue&type=template&id=df89da76&scoped=true&"
import script from "./Cookie_Policy.vue?vue&type=script&lang=js&"
export * from "./Cookie_Policy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df89da76",
  null
  
)

export default component.exports